module.exports = __webpack_public_path__ + "img/charts-pie-and-bars.49d6ae5a.svg";